import { createFileRoute, redirect } from "@tanstack/react-router";

// ID-only tool — 308 single-hop redirect to canonical ID URL.
export const Route = createFileRoute("/en/tools/day-calculator")({
  loader: () => {
    throw redirect({ to: "/tools/kalkulator-hari", code: 308 } as any);
  },
  component: () => null,
});